// Generated by CoffeeScript 2.7.0
import Admin__SettingsController from './settings.js';

import Admin__Settings__BasicController from './basic.js';

import Admin__Settings__PushTemplateController from './push_template.js';

import Admin__Settings__TencentWecityController from './tencent_wecity.js';

import Admin__Settings__CustomerServiceController from './customer_service.js';

import Admin__Settings__AttendanceController from './attendance.js';

import Admin__Settings__RegisterController from './register.js';

import Admin__Settings__WechatAuthorizedController from './wechat_authorized.js';

import Admin__Settings__WechatPayController from './wechat_pay.js';

import Admin__Settings__NamespaceStatusController from './namespace_status.js';

import Admin__Settings__OthersController from './others.js';

import Admin__Settings__RedPacketQuotasController from './red_packet_quotas.js';

import Admin__Settings__AdministrationsController from './administrations.js';

import Admin__Settings__NamecardsController from './namecard.js';

import Admin__Settings__BrandImagesPreferencesController from './brand_images_preferences.js';

import Admin__Settings__HelpHtmlsController from './help_htmls.js';

Skylark.App.Controllers.register({Admin__SettingsController, Admin__Settings__BasicController, Admin__Settings__PushTemplateController, Admin__Settings__TencentWecityController, Admin__Settings__CustomerServiceController, Admin__Settings__AttendanceController, Admin__Settings__RegisterController, Admin__Settings__WechatAuthorizedController, Admin__Settings__WechatPayController, Admin__Settings__NamespaceStatusController, Admin__Settings__OthersController, Admin__Settings__RedPacketQuotasController, Admin__Settings__AdministrationsController, Admin__Settings__NamecardsController, Admin__Settings__BrandImagesPreferencesController, Admin__Settings__HelpHtmlsController});
